import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postMarkCustomerAsInactive = (
    backend: string,
    token: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}customers/inactivate/${id}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }
    );
};

export default postMarkCustomerAsInactive;
